import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VContainer,{attrs:{"grid-list-md":"","fluid":""}},[_c(VLayout,{attrs:{"align-center":"","justify-space-around":"","wrap":""}},[_c(VFlex,{attrs:{"md8":""}},[_c(VCard,[_c(VLayout,[_c(VFlex,{attrs:{"xs5":""}},[_c(VImg,{attrs:{"max-height":"100px","max-width":"100px","contain":"","src":require(`@/assets/walrus.jpg`)}})],1),_c(VFlex,{attrs:{"xs7":""}},[_c(VCardTitle,{attrs:{"primary-title":""}},[_c('h3',{staticClass:"headline mb-0"},[_vm._v("ImageMaker")])]),_c(VCardText,[_vm._v("Make and download images")])],1)],1)],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }